<div style="display: flex; flex-direction: column">
  <!-- Panel de carga masiva de siniestros (nuevo) -->
  <app-bulk-load-sinister *ngIf="isAdminChilePeru"></app-bulk-load-sinister>

  <!-- Panel de carga masiva de estados de personas -->
  <app-bulk-load-status-person
    *ngIf="isAdminChilePeru"></app-bulk-load-status-person>
</div>
